
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import { ebisuShintoukiTopShintoukiImage } from "@src/constants/images";
export const meta = {
  path: "/media/ebisu/shintouki",
  title: "【閉店】【ディーンフジオカも絶賛！】恵比寿の「新東記」でカオマンガイ (チキンライス)を食べよう！",
  description: "エスニック料理の代表格として近年人気を上げているのがシンガポール料理。その中でも、恵比寿の「新東記」はシンガポール政府観光局の第一号認定のお店として、シンガポール料理の人気を牽引してきました！シンガポール人の監修、ディーンフジオカさんが絶賛する料理はどんなものなのか？恵比寿「新東記」の秘密に迫ります！",
  topImg: ebisuShintoukiTopShintoukiImage,
  author: murakamiMasanori
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><em parentName="p">{`【このお店は現在閉店しております】`}</em></p>
    <p>{`「シンガポール料理」と聞くと、馴染みがないかもしれないですが、カオマンガイ (チキンライス)や肉骨茶(バクテー)をはじめとして、馴染みの多い料理がたくさんあります！`}</p>
    <p>{`そのエスニック料理の代表格として、昔から人気を保ち続けているのが恵比寿の「新東記」。食べログの評価は 3.7(2020 年 5 月時点)で、シンガポール政府観光局の第一号認定のお店として有名なお店になっています！`}</p>
    <p>{`シンガポール人のオーナーが監修している本場の味に、ディーンフジオカさんも絶賛し、複数回店に足を運んでいるそうです。
今回はそんな恵比寿「新東記」についてご紹介させていただきます！`}</p>
    <hr></hr>
    <h2>{`恵比寿 新東記とは？`}</h2>
    <InstaImage postId="BPLbciLgZyh" mdxType="InstaImage" />
    <p>{`「新東記」は恵比寿でシンガポール料理が食べられるお店として、2005 年にオープン。
食べログの評価も 3.7(2020 年 5 月時点)と、お客様からずっと愛され続けているお店になっています。
特に人気なのが、カオマンガイ (チキンライス)と肉骨茶(バクテー)と言われていて、あのディーンフジオカさんも認めたお店だそうです！`}</p>
    <hr></hr>
    <h2>{`「新東記」は政府認定のお店！？`}</h2>
    <p>{`「新東記」はシンガポール政府観光局から認定されているお店の１つで、その中でも`}<strong parentName="p">{`なんと１号店`}</strong>{`として認められているんです！
1 番早くシンガポール料理店に認定されているということは、「新東記」の料理はオープン当初から本場の味に近い料理を出していたのだと思います！`}</p>
    {
      /* // 二枚目を表示 */
    }
    <InstaImage postId="BY3K-SvBubG" include={[1]} mdxType="InstaImage" />
    <h3>{`シンガポール人が料理を監修！？`}</h3>
    <p>{`「新東記」のオーナーでもあり、シンガポール人でもある`}<strong parentName="p">{`パトリシア・チア`}</strong>{`が「新東記」の料理を監修しているそうです！
「シンガポールの本場の味を日本で楽しめるところがない！」ということで立ち上げたそうで、本場の人が監修しているのは信頼感が増しますよね。`}</p>
    <hr></hr>
    <h2>{`「新東記」のメニュー`}</h2>
    <h3>{`1 番人気のカオマンガイ (チキンライス)がこちら！`}</h3>
    <p>{`ぷりっぷりの鶏肉と香りが華やかなジャスミンライスと一緒に食べます！
私が食べた時も、「ジャスミンライスっておいしいのかな？」と思っていたのですが、食感は日本のお米のモチモチ感があります。
さらに、チキンライスの色んな風味によって、またその印象が変わり、驚くほど食べやすくクセになる味です！`}</p>
    <InstaImage postId="B0kVdwZAIem" mdxType="InstaImage" />
    <h3>{`３種類のソースをつけてカオマンガイ (チキンライス)を食べる！`}</h3>
    <p>{`チリソース、ショウガソース、黒酢ソースの３つで味を楽しめるようになっており、全く飽きないし、ジャスミンライスがすすみます笑`}</p>
    <InstaImage postId="BjAFsholqpl" mdxType="InstaImage" />
    <h3>{`ディーンフジオカも絶賛した肉骨茶(バクテー)`}</h3>
    <InstaImage postId="B_iYEbwl8Si" mdxType="InstaImage" />
    <p>{`食事に対して強いこだわりを持つことで有名な:`}<strong parentName="p">{`ディーンフジオカ`}</strong>{`さんが、1 番美味しい肉骨茶(バクテー)として認めたのが「新東記」の肉骨茶(バクテー)。
ディーンフジオカさんは、中国や台湾での生活が長かったことから、いろんな味の肉骨茶バクテーを食べてきたのだと思います。`}</p>
    <p>{`そんな肉骨茶(バクテー)がこちらです！`}</p>
    <InstaImage postId="By60QnIhd8P" mdxType="InstaImage" />
    <p>{`一時期は、『肉骨茶　ディーンスペシャル』という名前がついたメニューも出されたそう！
一気にお店は有名になったそうですが、その後も３回ほどディーンフジオカさんはご来店されているそうで、一度は食べてみたい一品ですよね！`}</p>
    <h3>{`代表的なランチメニューはこちらから！`}</h3>
    <h4>{`SET A(1,280 円)`}</h4>
    <p>{`海南鶏飯 + ミニ肉骨茶 + デザート(Drink & Dessert ドリンク付)　※土日祝は 1,580 円`}</p>
    <InstaImage postId="Bql9dPjAxmp" mdxType="InstaImage" />
    <h4>{`SET B(1,280 円)`}</h4>
    <p>{`海南鶏飯 + ミニラクサ + デザート(Drink & Dessert ドリンク付)　※土日祝は 1,580 円`}</p>
    <InstaImage postId="BcXXbbAhWls" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`電子マネーも使えるお店！`}</h2>
    <p>{`現金だけのお店が多い印象ですが、PayPay が使えるお店としても有名です！
決済が楽なのも「新東記」の人気の理由ですね！`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`恵比寿駅の西口から目黒方面に山手線沿いを歩いて徒歩 5 分で到着できます！
なので、かなり好立地なのも「新東記」の人気の秘密ですよね...！`}</p>
    <GoogleMap lat={35.6451728} lng={139.708404} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`恵比寿の人気のシンガポール料理店「新東記」をご紹介してきました！
あのディーンフジオカさんも認めたお店や、人気のカオマンガイ (チキンライス)、肉骨茶(バクテー)を是非楽しんでみてください...！`}</p>

    <p>{`;`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;